module.exports = __webpack_public_path__ + "img/footer-hex.aefa3ca4.svg";